import { BContainer } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

/** Bootstrap-vue bridge — replace this file with your own EgBContainer when migrating. */
export const EgBContainer = createEgBootstrapProxy("EgBContainer", BContainer);
